export default "__VITE_PUBLIC_ASSET__7707d1fb__"